export default __webpack_public_path__ + "static/media/arrowNext.be65882e.svg";